import { actionHandler } from "../api";

const args = {
    application_no: '',
    db_name: ''
};



const CreateAccountQ = `api/method/guidestar.api.user.get_data_user_profile`

// Convert the args object to a JSON string and encode it for use in a URL
const argsJsonString = encodeURIComponent(JSON.stringify(args));

const DataUserCreateAccountUrl = `api/method/guidestar.api.user.make_data_user_profile`
const EditDataUserCreateAccountUrl = `api/method/guidestar.api.user.make_data_user_profile`


export const DataUserCreateAccount = async (payload) => {
    try {
        const { data } = await actionHandler({
            url: DataUserCreateAccountUrl,
            method: 'POST',
            data: payload,
        });

        return data;
    } catch (error) {
        throw error;
    }
}
export const EditDataUserCreateAccount = async (payload) => {
    try {
        const { data } = await actionHandler({
            url: EditDataUserCreateAccountUrl,
            method: 'POST',
            data: payload,
        });

        return data;
    } catch (error) {
        throw error;
    }
}

export const CreateAccountGet = async (key) => {
    try {
        const setEmail = {
            'email': `${key ? key : ''}`,
        };

        // / Convert the args object to a JSON string and encode it for use in a URL
        const args = JSON.stringify(setEmail);
        const { data } = await actionHandler({
            url: `${CreateAccountQ}?args=${args}`,
            method: 'GET',
        });
        return data
    } catch (error) {
        throw error
    }
}